var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_9334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0344 19.8221C22.199 17.3008 22.2857 14.6837 22.2857 12C22.2857 11.2698 22.2794 10.5445 22.2667 9.82464C22.243 8.48079 21.8117 7.1693 20.9883 6.10692C19.5742 4.28213 18.3153 3.02463 16.3665 1.53927C15.8229 1.12492 15.1594 0.899575 14.4761 0.884025C13.6938 0.866226 12.8761 0.857178 12 0.857178C9.35904 0.857178 7.24944 0.93939 5.03781 1.09572C3.38609 1.21248 2.07352 2.52561 1.96562 4.17792C1.80098 6.69936 1.71429 9.31632 1.71429 12C1.71429 14.6837 1.80098 17.3008 1.96562 19.8221C2.07352 21.4745 3.38609 22.7875 5.03781 22.9043C7.24944 23.0606 9.35902 23.1429 12 23.1429C14.641 23.1429 16.7506 23.0606 18.9622 22.9043C20.6139 22.7875 21.9266 21.4745 22.0344 19.8221Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84402 9.97173C7.84402 9.97173 8.75515 7.1316 10.2537 6.94918C11.9255 6.74566 11.6486 10.0718 13.3298 9.97173C15.1425 9.8638 15.8932 6.09204 15.8932 6.09204",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74106 14.0432H16.2589",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74106 18.0076H16.2589",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_9334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBlackIcon);
export default __webpack_public_path__ + "static/media/test-black-icon.027eac204d7e340ba5432cc8a482c6ca.svg";
export { ForwardRef as ReactComponent };